module.exports = {"data":{"site":{"siteMetadata":{"title":"Moritz Roth","description":"Personal homepage of Moritz Roth.","author":{"name":"Moritz Roth","url":"https://github.com/mroth23"},"siteUrl":"https://mroth.io/"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 108
// module chunks = 22676092666560 60335399758886